import { render, staticRenderFns } from "./ContractsTemplates.vue?vue&type=template&id=9c05dff0"
import script from "./ContractsTemplates.vue?vue&type=script&lang=js"
export * from "./ContractsTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports